import React from 'react';

import type { HexColor } from 'common/colors/utils';
import ColorInput from 'common/inputs/ColorInput';
import ButtonLink from 'common/uiV3/Button/ButtonLink';
import Field from 'common/uiV3/Field';
import Flex from 'common/uiV3/Flex';
import VStack from 'common/uiV3/VStack';

type Props = {
  color: HexColor;
  onColorPicked: (color: HexColor) => void;
  error?: string | null;
};

const BrandColorPicker = ({ color, onColorPicked, error }: Props) => (
  <Field orientation="horizontal" className="justify-between">
    <VStack className="gap-2">
      <Field.Label>Brand color</Field.Label>
      <Field.Description className="text-base">
        Assign a brand color to your public feedback portal while ensuring accessibility with our
        contrast&nbsp;checker.{' '}
        <ButtonLink
          variant="link"
          target="_blank"
          href="https://www.w3.org/WAI/WCAG21/Understanding/contrast-minimum.html"
          rel="noopener noreferrer">
          Learn more about&nbsp;contrast.
        </ButtonLink>
      </Field.Description>
      {error && <Field.Error>{error}</Field.Error>}
    </VStack>
    <Field.Content className="items-end">
      <Flex className="min-w-40 max-w-40">
        <ColorInput defaultValue={color} onChange={(value) => onColorPicked(value as HexColor)} />
      </Flex>
    </Field.Content>
  </Field>
);

export default BrandColorPicker;
